import * as AF from "@/components/form-items/AbstractForm";
import { ModifiableList } from "@/components/form-items/ModifiableList";
import { useTranslation } from "react-i18next";

const SculptureEditionCertificatTab = () => {
  const { t } = useTranslation();

  return (
    <AF.Col className="gap-6">
      <ModifiableList
        name="sculptureEditionCertificatAuteur"
        listKey="liste-auteur-certificat"
        label={t("sculpture.edition.certificatAuteur")}
      />

      <AF.Text
        name="sculptureEditionCertificatLocalisationOriginal"
        label={t("sculpture.edition.certificatLocalisationOriginal")}
      />

      <AF.Checkbox
        name="sculptureEditionCertificatCopieExistante"
        label={t("sculpture.edition.certificatCopieExistante")}
      />

      <ModifiableList
        name="sculptureEditionCertificatLocalisationCopie"
        listKey="liste-localisation-certificat"
        label={t("sculpture.edition.certificatLocalisationCopie")}
      />

      <ModifiableList
        name="sculptureEditionCertificatDate"
        listKey="liste-date-certificat"
        label={t("sculpture.edition.certificatDate")}
      />

      <AF.RichText
        name="sculptureEditionCertificatNotes"
        label={t("sculpture.edition.certificatNotes")}
        className="min-h-[200px]"
      />
    </AF.Col>
  );
};

export default SculptureEditionCertificatTab;
